import CompaniesRepository from "./CompaniesRepository";
import TenantsRepository from "./TenantsRepository";
import EmployeesRepository from "./EmployeesRepository";
import UsersRepository from "./UsersRepository";
import GroupsRepository from "./GroupsRepository";
import GroupTypesRespository from "./GroupTypesRepository";
import ContactsRepository from "./ContactsRepository";
import TrainingRepository from "./TrainingRepository";
import TrainingCategoryRepository from "./TrainingCategoryRepository";
import TrainingTopicRepository from "./TrainingTopicRepository";
import TrainingGroupRepository from "./TrainingGroupRepository";
import AssessmentRepository from "./AssessmentRepository";
import QuestionRepository from "./QuestionRepository";
import AssignmentRepository from "./AssignmentRepository";
import DocumentsRepository from "./DocumentsRepository";
import DocumentGroupsRepository from "./DocumentGroupsRepository";
import ReportsRepository from "./ReportsRepository";
import QuestionReviewRepository from "./QuestionReviewRepository";
import SsoRepository from "./SsoRepository";

export const Api = {
  companies: CompaniesRepository,
  tenants: TenantsRepository,
  employees: EmployeesRepository,
  users: UsersRepository,
  groups: GroupsRepository,
  groupTypes: GroupTypesRespository,
  contacts: ContactsRepository,
  training: TrainingRepository,
  trainingCategory: TrainingCategoryRepository,
  trainingTopics: TrainingTopicRepository,
  trainingGroup: TrainingGroupRepository,
  assessment: AssessmentRepository,
  question: QuestionRepository,
  assignment: AssignmentRepository,
  documents: DocumentsRepository,
  documentGroups: DocumentGroupsRepository,
  reports: ReportsRepository,
  questionReview: QuestionReviewRepository,
  sso: SsoRepository
};
